// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Krishna",
  middleName: "",
  lastName: "Purohit",
  message: " Computing with care. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/krizh-p",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/krizhp/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/pfp.png"),
  imageSize: 375,
  message:
    "Hey, I'm Krishna, a student at George Mason University pursuing a B.S. in Computer Science. I’m a tech enthusiast who loves to learn new tools and use my skills to make a positive difference in the world. I've had experience in many different avenues ranging from cloud computing, consulting as a project manager, election canvassing, and interning for various organizations. I've gained and applied data analysis, algorithmic thinking, and Agile methodology skills to deliver impactful results. I also love working on projects in programming, such as with Java, machine learning, and drone/unmanned aerial systems prototyping--which has earned me some prestigious certifications and awards. In my spare time, I like to do something peaceful like hiking or rowing.",
  resume: require("../editable-stuff/resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "krizh-p", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["Microsoft-NASA-AI-Windmill-Detector", "AI-Face-Instructional-Manual", "Monument", "algorithmic_trader-python"],
};

const video = {
  show: true,
  heading: "Blog?",
  url: "https://www.youtube.com/watch?v=1uOw22P36GA&ab_channel=Krizh"
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Blog?",
  message:
    "Attatched here is a link to a video I recently created for my summer class, ENG388, where I teach you how to train an AI model to generate images with your face in them.",
  images: [
    { 
      img: require("../editable-stuff/pfp.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/pfp.png"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Java", value: 90 },
    { name: "Python", value: 75 },
    { name: "Data Structures", value: 85 },
    { name: "C/C++", value: 65 },
    { name: "JavaScript", value: 90 },
    { name: "HTML/CSS", value: 70 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 100 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Software Engineering or Machine Learning opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free call at 703-889-0945 or to email me at",
  email : "krizh822@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experience",
  data: [
    {
      role: 'Volkswagen Credit, Inc.',// Here Add Company Name
      companylogo: require('../assets/img/vci.jpg'),
      date: 'Intern Cloud Engineer',
    },
    {
      role: 'Microsoft, NASA',// Here Add Company Name
      companylogo: require('../assets/img/space.png'),
      date: 'Hackathon AI Engineer',
    },
    {
      role: 'George Mason University',// Here Add Company Name
      companylogo: require('../assets/img/gmu.jpg'),
      date: 'Student Instructor for CS395',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences, video };